import React from 'react'

interface IconProps {
  classes?: string
}

export const Arrow = ({ classes = '' }: IconProps) => {
  return (
    <svg
      className={classes}
      data-testid='TextLinkIcons-arrow'
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.5312 13.0001H7.45117M17.5312 13.0001L13.5107 8.68005M17.5312 13.0001L13.5107 17.3201'
        stroke='#2B4FB9'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const Download = ({ classes = '' }: IconProps) => {
  return (
    <svg
      className={classes}
      data-testid='TextLinkIcons-download'
      height='14px'
      viewBox='0 0 30 30'
      width='14px'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.5,23.4a1.08,1.08,0,0,0,.76.31h0a1,1,0,0,0,.75-.32l8.55-8.76A1.07,1.07,0,0,0,23,13.14L16.33,20V1.07a1.07,1.07,0,1,0-2.14,0v19L7.25,13.13a1.06,1.06,0,0,0-1.51,0,1.08,1.08,0,0,0,0,1.51Z'
        fill=''
      />
      <path
        d='M28.93,27.56H1.16a1.07,1.07,0,0,0,0,2.14H28.93a1.07,1.07,0,0,0,0-2.14Z'
        fill=''
      />
    </svg>
  )
}

export const ChevronDown = ({ classes = '' }: IconProps) => {
  return (
    <svg
      className={classes}
      data-testid='TextLinkIcons-chevronDown'
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 10.05L12 13.95L8 10.05'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='1.5'
      />
    </svg>
  )
}
